import { ConstanteService } from './../../_services/constante.service';
import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Segmento } from '../../_models/segmento';
import { ProductoService } from '../../_services/producto.service';
import { forkJoin, Observable } from 'rxjs';
import { SegmentoNivelEndeudamiento } from '../../_models/segmento-nivel-endeudamiento';
import { SegmentoNivelEndeudamientoService } from '../../_services/segmento-nivel-endeudamiento.service';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import {PoliticasCreditoService} from '../../_services/politicas-credito.service';
import {PoliticasCredito} from '../../_models/politicas-credito';
import {PoliticaService} from '../../_services/politica.service';
import {Politica} from '../../_models/politica';
import {CodigosPoliticas} from '../../_enums/enum';
import { SegmentosService } from '../../_services/segmentos.service';

@Component( {
  templateUrl: 'segmento-endeudamiento.component.html',
    selector: 'app-segmento-endeudamiento',
  providers: [ ConfirmationService ]
} )
export class SegmentoEndeudamientoComponent implements OnInit {
  @Input() detalle: boolean = false;
  columnas: any[];
  formulario: FormGroup;
  carSegmentoProducto: boolean;
  segmentoNivelEndeudamientos: SegmentoNivelEndeudamiento[] = [];
  @Input()
  segmento: Segmento;
  @Input()
  segmentoTemp: any;
  @Input() constanteNIVEND: any;
  submitted: boolean;
  guardando: boolean;
  // listPolitcas : PoliticasCredito[] = [];
  listPolitcas : Politica[] = [];
  politicaCreditos: SelectItem[];

  idPoliticaCredito: string;
  formularioEndeudamiento : FormGroup;
  labelIndicador: string = 'Sin configuración';

  constructor( private navServicio: NavService,
               private router: Router,
               private formBuilder: FormBuilder,
               private segmentoNivelEndeudamientoService: SegmentoNivelEndeudamientoService,
               private productosService: ProductoService,
               private listaService: ListaService,
               private confirmacionServicio: ConfirmationService,
               private politicaService: PoliticasCreditoService,
               private newPoliticaService: PoliticaService,
               private segmentosService:SegmentosService) {
  }


  ngOnInit(): void {
    /* this.formulario = this.formBuilder.group( {
      idPoliticaCredito: [ '', [ Validators.required ] ],
      indicadorHabilitado: [ true ]
    } );
    this.columnas = [
      { field: 'codigoPolticaCredito', header: this.navServicio.buscarMensaje( 'SEGMENTOSENDEUDAMIENTO.LBL_CODIGO' ), sort: true },
      { field: 'polticaCredito', header: this.navServicio.buscarMensaje( 'SEGMENTOSENDEUDAMIENTO.LBL_POLITICAS' ), sort: true },
      {field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje('SEGMENTOS.LBL_HABILITADO'), sort: true},
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: true },
    ];
    forkJoin( this.newPoliticaService.obtenerPoliticaPorCodigoHabilitada(CodigosPoliticas.PoliticaPreselecta),
      this.segmentoNivelEndeudamientoService.obtenerPorSegmento( this.segmento.idSegmento ) ).
      subscribe( ( [ res1, res2 ] ) => {
      this.listPolitcas = res1;
      this.segmentoNivelEndeudamientos = res2;
      this.carDropdown();
    }, ( err1 ) => {
      this.navServicio.setMesage( 4, {
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo cargar la información. Intente nuevamente.'
      } );
    } ); */

    console.log(this.segmento);

    if (this.constanteNIVEND) {
      this.labelIndicador = this.navServicio.buscarMensaje( 'EJECUTIVOS_FASE2.LBL_ENDEUDAMIENTO' ) +
      this.constanteNIVEND.valor + this.navServicio.buscarMensaje( 'EJECUTIVOS_FASE2.LBL_NOMSALARIO' )
    }

    this.formularioEndeudamiento = this.formBuilder.group({
      indicadorNivelEndeudamiento: [false],
    });

    if(this.segmento.indicadorNivelEndeudamiento !== null && this.segmento.indicadorNivelEndeudamiento !== undefined ){
      this.f.indicadorNivelEndeudamiento.setValue(this.segmento.indicadorNivelEndeudamiento);
    }

    if(this.segmento.indicadorHabilitado){
      this.formularioEndeudamiento.disable();
    }


  }

  get f() {
    return this.formularioEndeudamiento.controls;
  }

  onSubmit(){
    this.submitted = true;
    if ( this.formularioEndeudamiento.valid ){
      const temp: Segmento = this.segmento;
      temp.indicadorNivelEndeudamiento = this.f.indicadorNivelEndeudamiento.value;
      console.log(temp.indicadorNivelEndeudamiento);
      this.segmentosService.actualizar( temp ).subscribe( res => {
        console.log(res);
        this.submitted = false;
        this.navServicio.setMesage( 1 );
      });
    }
  }

  /* carDropdown(): void {
    this.politicaCreditos = [];
    this.listPolitcas.map( p => {
      if ( p.indicadorHabilitado && !this.segmentoNivelEndeudamientos.find(
        sp => sp.indicadorHabilitado && sp.idPoliticaCredito === p.idPolitica ) ) {
        this.politicaCreditos.push( { label: p.nombre, value: p.idPolitica } );
      }
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  get segNivelesEndeudamientos() {
    return this.segmentoNivelEndeudamientos.filter( s => s.indicadorHabilitado );
  }

  onSubmit(): void {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.carSegmentoProducto = true;
      const temp: SegmentoNivelEndeudamiento = this.formulario.value;
      temp.idSegmento = this.segmento.idSegmento;
      temp.polticaCredito = this.listPolitcas.find( p => p.idPolitica === temp.idPoliticaCredito )
        .nombre;
      const a = this.segmentoNivelEndeudamientos.find( sp => sp.idPoliticaCredito === temp.idPoliticaCredito );
      if ( a ) {
        temp.idSegmentoNivelEndeudamiento = a.idSegmentoNivelEndeudamiento;
      }
      temp.indicadorHabilitado = true;
      if ( temp.idSegmentoNivelEndeudamiento ) {
        this.segmentoNivelEndeudamientoService.actualizar( temp ).subscribe( res => {
          const tempSegmentoP: SegmentoNivelEndeudamiento[] = this.segmentoNivelEndeudamientos;
          this.segmentoNivelEndeudamientos = [];
          tempSegmentoP.map( t => {
            if ( t.idSegmentoNivelEndeudamiento === temp.idSegmentoNivelEndeudamiento ) {
              t.indicadorHabilitado = true;
            }
          } );
          this.segmentoNivelEndeudamientos = tempSegmentoP;
          this.carDropdown();
          this.formulario.reset();
          this.submitted = false;
          this.carSegmentoProducto = false;
          this.navServicio.setMesage( 2 );
        } );
      } else {
        this.segmentoNivelEndeudamientoService.agregar( temp ).subscribe( res => {
          temp.idSegmentoNivelEndeudamiento = res.idSegmentoNivelEndeudamiento;
          temp.codigoPolticaCredito = this.listPolitcas.find( po => po.idPolitica === temp.idPoliticaCredito).codigo;
          this.segmentoNivelEndeudamientos.push( temp );
          this.carDropdown();
          this.formulario.reset();
          this.submitted = false;
          this.carSegmentoProducto = false;
          this.navServicio.setMesage( 1 );
        } );
      }
    } else {
      return;
    }
  }

  disable( row: SegmentoNivelEndeudamiento ): void {
    this.confirmacionServicio.confirm( {
      message: '¿Está seguro que desea inactivar este registro?',
      header: 'Nivel de endeudamiento',
      icon: 'fa fa-question-circle',
      key: 'nivelEndeudamiento',
      accept: () => {
        row.indicadorHabilitado = false;
        this.segmentoNivelEndeudamientoService.actualizar( row ).subscribe( res => {
          const temp: SegmentoNivelEndeudamiento[] = this.segmentoNivelEndeudamientos;
          this.segmentoNivelEndeudamientos = [];
          temp.map( t => {
            if ( t.idSegmentoNivelEndeudamiento === row.idSegmentoNivelEndeudamiento ) {
              t.indicadorHabilitado = false;
            }
          } );
          this.segmentoNivelEndeudamientos = temp;
          this.carDropdown();
        } );
      }
    } );
  } */
}
